import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
import { LogLevel } from '@wix/panorama-common-shared/types';
export class PanoramaLoggerImpl {
  constructor(baseClient) {
    this.baseClient = baseClient;
    bindPrototypeMethodsToSelf(this);
  }
  info(message, data) {
    this.baseClient.log(LogLevel.Info, message, data);
  }
  warn(message, data) {
    this.baseClient.log(LogLevel.Warn, message, data);
  }
  error(message, data) {
    this.baseClient.log(LogLevel.Error, message, data);
  }
  debug(message, data) {
    this.baseClient.log(LogLevel.Debug, message, data);
  }
}
//# sourceMappingURL=panorama-logger.js.map